import { providerLogger } from '@ragu-components/logger';
import { buildUrl } from '@ragu-components/ord-providers';

import type { UrlOptions } from '@ragu-components/ord-providers';
import type { AxiosInstance } from 'axios';
import type {
  CreateParams,
  CreateResult,
  DataProvider,
  DeleteManyParams,
  DeleteManyResult,
  DeleteParams,
  DeleteResult,
  GetListParams,
  GetListResult,
  GetManyParams,
  GetManyReferenceParams,
  GetManyReferenceResult,
  GetManyResult,
  GetOneParams,
  GetOneResult,
  RaRecord,
  UpdateManyParams,
  UpdateManyResult,
  UpdateParams,
  UpdateResult,
} from 'react-admin';

export const createTasksDataProvider = (
  dataProvider: DataProvider,
  realmId: string,
  axiosInstance: AxiosInstance | undefined
): DataProvider => {
  return {
    getList: async (resource: string, params: GetListParams): Promise<GetListResult> =>
      dataProvider.getList(resource, params),
    getOne: async (resource: string, params: GetOneParams<RaRecord>): Promise<GetOneResult> => {
      if (axiosInstance === undefined) {
        providerLogger.error('axiosInstance is undefined');
        return { data: {} };
      }
      providerLogger.debug('getOne task', resource, params);
      const { id, meta } = params;
      const url = buildUrl(resource, { realmId, id, ...(meta as UrlOptions) });
      const response = await axiosInstance.get<RaRecord>(url);
      return { data: { ...response.data, id, location: response.headers.location } };
    },
    getMany: async (resource: string, params: GetManyParams): Promise<GetManyResult> =>
      dataProvider.getMany(resource, params),
    getManyReference: async (resource: string, params: GetManyReferenceParams): Promise<GetManyReferenceResult> =>
      dataProvider.getManyReference(resource, params),
    create: async (resource: string, params: CreateParams): Promise<CreateResult> =>
      dataProvider.create(resource, params),
    update: async (resource: string, params: UpdateParams<RaRecord>): Promise<UpdateResult> =>
      dataProvider.update(resource, params),
    updateMany: async (resource: string, params: UpdateManyParams): Promise<UpdateManyResult> =>
      dataProvider.updateMany(resource, params),
    delete: async (resource: string, params: DeleteParams<RaRecord>): Promise<DeleteResult> =>
      dataProvider.delete(resource, params),
    deleteMany: async (resource: string, params: DeleteManyParams<RaRecord>): Promise<DeleteManyResult> =>
      dataProvider.deleteMany(resource, params),
  };
};
